import { useIntl } from 'react-intl'

import ButtonCinestar from '../../../Buttons/ButtonCinestar/ButtonCinestar'
import Typography from '../../../Typography/Typography'
import BasketItem from '../BasketItem/BasketItem'

import './Seats.scss'

const Seats = ({ selectedSeats, onConfirm, loading }) => {
    const intl = useIntl()

    return (
        <div className="d-flex justify-content-between">
            <div className="selected-seats-wrapper d-flex">
                <Typography variant={'label'} color={'basePrimary'}>
                    {intl.formatMessage({ id: 'basket.selectedSeats' })}
                </Typography>
                <div className="basket-list">
                    {selectedSeats.map((seat, indx) => (
                        <BasketItem key={`basket-item-${indx}`} data={seat} selectedSeats={selectedSeats} />
                    ))}
                </div>
            </div>
            <div className="btn-wrapper my-auto ms-auto">
                <ButtonCinestar disabled={loading} variant={'primary-v1'} onClick={onConfirm}>
                    {intl.formatMessage({ id: 'basket.btn' })}
                </ButtonCinestar>
            </div>
        </div>
    )
}

export default Seats
